import { Flex, Grid } from '@jutro/layout';
import isString from "lodash/isString";
const layoutComponentMap = {
  flex: Flex,
  grid: Grid,
  div: 'div',
  Flex,
  Grid
};
export const getLayoutComponent = component => {
  return isString(component) ? layoutComponentMap[component] || layoutComponentMap.div : component;
};